exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.pagination-content[data-v-a5ffbb3a]{margin-top:3px;margin-left:10px\n}\n::v-deep .el-pagination[data-v-a5ffbb3a]{padding:6px 5px\n}", "", {"version":3,"sources":["/var/jenkins_home/workspace/eitpm-pre-pc-web/src/components/pager.vue"],"names":[],"mappings":";AAyEA,qCACE,eACA,gBAAA;CAGF;AAAA,yCACE,eAAA;CAAA","file":"pager.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.pagination-content {\n  margin-top: 3px;\n  margin-left: 10px;\n  // text-align: right;\n}\n::v-deep .el-pagination {\n  padding: 6px 5px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a5ffbb3a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pager.vue
// module id = /G0p
// module chunks = 64